import TypeUtil from '@/util/TypeUtil';
import {CSSProperties} from 'vue';

export default class ThemeOverrideUtil {
    public readonly themeOverrides: CSSProperties = {};

    constructor(private readonly preferences: Record<string, string | number>) {
        this.addThemeColorOverride('--workload-requirement-below-minimum', 'themeColor:requirementBelowMinimum');
        this.addThemeColorOverride('--workload-requirement-below-optimum', 'themeColor:requirementBelowOptimum');
        this.addThemeColorOverride('--workload-requirement-optimum', 'themeColor:requirementOptimum');
        this.addThemeColorOverride('--workload-requirement-above-optimum', 'themeColor:requirementAboveOptimum');
        this.addThemeColorOverride('--workload-requirement-above-maximum', 'themeColor:requirementAboveMaximum');
        this.addThemeColorOverride('--work-schedule-status-full', 'themeColor:workScheduleStatusFull');
        this.addThemeColorOverride('--work-schedule-status-partial', 'themeColor:workScheduleStatusPartial');
        this.addThemeColorOverride('--work-schedule-status-none', 'themeColor:workScheduleStatusNone');
    }

    private addThemeColorOverride(name: `--${string}`, sourceName: string): void {
        if (sourceName in this.preferences && TypeUtil.isValidCSSHexColorString(this.preferences[sourceName])) {
            this.themeOverrides[name] = this.preferences[sourceName];
        } else {
            this.themeOverrides[name] = undefined;
        }
    }
}
